"use strict";

angular.module('rmToken')
	.config(['$stateProvider', function ($stateProvider) {

		$stateProvider
			.state('token', {
				url: "/tokens",
				templateUrl: '/partial/app.partials.oauth.overview',
				controller: 'TokenOverviewCtrl',
				controllerAs: 'tokenCtrl'
			});
	}]);
